module.exports = __webpack_public_path__ + "img/driven_poster.7965e6b7.jpg";